import { atlas } from '~/services/serviceInstances';

import { GuidelineWithId } from '../../types/playbooks/guidelines';

export const updateGuideline = async (
  guideline: GuidelineWithId,
): Promise<{ data: { uuid: string } }> => {
  return atlas.patch(`guidelines/${guideline.uuid}`, {
    data: {
      type: 'guideline',
      attributes: guideline,
    },
  });
};
